import postal from 'postal';
import { setLocationHash } from '../shared/location';
import {
  selectTabByHash,
  convertTabPanelIdToDataAttribute,
} from '../shared/tab-sets';

function setUpTabSets() {
  $('section[data-role=tab-panel]')
    .each((i, element) => convertTabPanelIdToDataAttribute($(element)));

  // trigger the tab in the current location hash, if present
  selectTabByHash(window.location.hash);

  // trigger the tab when clicking a nav link
  $(document).on('click', 'section[data-role=tab-set] nav ul li a', function clickHandler() {
    const hash = $(this).attr('href');

    if (selectTabByHash(hash)) {
      setLocationHash(hash);
    }

    return false;
  });

  // trigger the tab on hash change, if present. Note that clicking a link will
  // trigger this event, causing a loop, but since the tab is already active
  // selectTabByHash() will exit early and return false in the click handler,
  // stopping the loop.
  postal.subscribe({
    channel: 'window.events',
    topic: 'location-state-changed',
    callback: () => selectTabByHash(window.location.hash),
  });
}

export default function bootstrap() {
  setUpTabSets();
}
